import {Breadcrumb} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useWindowSize} from "../../../hooks";

export function ABBreadcrumbs({breadcrumbList = []}) {
    const {width} = useWindowSize()
    const isMobile = width <= 576

    return <>
        <Breadcrumb className={`mt-2 ${isMobile ? "small" : ""}`}>
            {breadcrumbList.map((item, i) => (
                <Breadcrumb.Item
                    key={i}
                    linkAs={Link}
                    linkProps={{ to: item.to}}
                    active={i === breadcrumbList.length - 1}
                >
                    {isMobile && item.shortName ? item.shortName : item.name}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>

    </>
}